export const COLOR = {
  white: "#edf1f2",
  black: "#120e0d",

  brand: "#0092dd",
  contrast: "#dd4a00",

  barbie: "#D946EF",

  qverse: "#071228",

  opayGreen: "#1dcf9f",
  opayBlue: "#200f5f",

  chartBg: "#00bc7d26",
  chartFg: "#00bc7d",

  info: "oklch(0.488 0.243 264.376)",
  success: "oklch(0.696 0.17 162.48)",
  warning: "oklch(0.769 0.188 70.08)",
  danger: "oklch(0.645 0.246 16.439)",
} as const;
